'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = { each: _each3.default };

var _module = _angular2.default.module('cb.ui-components.content-filter.content-filter-category-controller', []);

_module.controller('ContentFilterCategoryController', ContentFilterCategoryController);

exports.default = _module;


function ContentFilterCategoryController() {
    var vm = this;

    vm.setActive = setActive;

    function setActive() {
        vm.cbContentFilter.setActive(vm.cbCategoryName);
    }

    vm.isActive = isActive;

    function isActive() {
        return vm.cbContentFilter.isActive(vm.cbCategoryName);
    }

    vm.$onInit = function () {
        vm.cbContentFilter.registerCategory(vm.cbCategoryName);

        if (typeof vm.cbFilterIsDefaultActive !== 'undefined') {
            vm.cbContentFilter.setActive(vm.cbCategoryName);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/content-filter/cb-content-filter-category.controller.js
// module id = 876
// module chunks = 0